import _regeneratorRuntime from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { ItemComponent } from "./ItemComponent";
import { ActionItem } from "./ActionItem";
import { Icon, ICONS } from "../..";
import { globalNav } from "./GlobalNav";
import { STATIC_URL } from "../../config";
var LOCALSTORAGE_NAVBAR_CONFIG_KEY = "@vseth/navbar_config";
var CONFIG_FILE_URL = "".concat(STATIC_URL, "/config/navbar-extern.json");
var VSETH_LOGO_FILE_URL = "".concat(STATIC_URL, "/assets/0000/logo-mono.svg");
var VSETH_SIGNET_FILE = "".concat(STATIC_URL, "/assets/0000/signet.svg");
/**
 *
 * @param items List of Items
 * @param lang language code (eg. "en" or "de")
 *
 * Takes an Item array and returns an Item array where every title is in the target language if possible, defaults to "en" if unavailable
 */

function translate(items, lang) {
  return items.map(function (item) {
    return Object.assign(Object.assign({}, item), {
      title: typeof item.title === "string" || item.title === undefined ? item.title : item.title[lang] ? item.title[lang] : item.title["en"],
      childItems: item.childItems ? translate(item.childItems, lang) : item.childItems
    });
  });
}

export var VSETHNavbar = function VSETHNavbar(_ref) {
  var _ref$primaryLogo = _ref.primaryLogo,
      primaryLogo = _ref$primaryLogo === void 0 ? React.createElement("a", {
    className: "navbar-brand white-brand",
    href: "#"
  }, React.createElement("img", {
    className: "",
    src: VSETH_LOGO_FILE_URL,
    height: "30px",
    style: {
      filter: "brightness(0) invert(1)"
    }
  })) : _ref$primaryLogo,
      _ref$primarySignet = _ref.primarySignet,
      primarySignet = _ref$primarySignet === void 0 ? React.createElement(Icon, {
    icon: ICONS.VSETH,
    className: "logo",
    color: "#009FE3"
  }) : _ref$primarySignet,
      _ref$primaryItems = _ref.primaryItems,
      primaryItems = _ref$primaryItems === void 0 ? [] : _ref$primaryItems,
      _ref$primaryActionIte = _ref.primaryActionItems,
      primaryActionItems = _ref$primaryActionIte === void 0 ? [] : _ref$primaryActionIte,
      _ref$primarySlot = _ref.primarySlot,
      primarySlot = _ref$primarySlot === void 0 ? null : _ref$primarySlot,
      _ref$secondarySlot = _ref.secondarySlot,
      secondarySlot = _ref$secondarySlot === void 0 ? null : _ref$secondarySlot,
      _ref$mobileTopSlot = _ref.mobileTopSlot,
      mobileTopSlot = _ref$mobileTopSlot === void 0 ? null : _ref$mobileTopSlot,
      _ref$drawerSlot = _ref.drawerSlot,
      drawerSlot = _ref$drawerSlot === void 0 ? null : _ref$drawerSlot,
      _ref$secondaryNavItem = _ref.secondaryNavItems,
      secondaryNavItems = _ref$secondaryNavItem === void 0 ? [] : _ref$secondaryNavItem,
      _ref$secondaryLogo = _ref.secondaryLogo,
      secondaryLogo = _ref$secondaryLogo === void 0 ? null : _ref$secondaryLogo,
      _ref$secondarySignet = _ref.secondarySignet,
      secondarySignet = _ref$secondarySignet === void 0 ? null : _ref$secondarySignet,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "en" : _ref$lang;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1]; // Get saved config from store, if unavailable, default to GlobalNav.ts


  var storedConfig = localStorage.getItem(LOCALSTORAGE_NAVBAR_CONFIG_KEY);

  var _React$useState = React.useState(storedConfig ? JSON.parse(storedConfig) : globalNav),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      config = _React$useState2[0],
      setConfig = _React$useState2[1]; // Try to load new Navbar config, save and replace it with new one if it changed


  useEffect(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var response, navConfig, stringified;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(CONFIG_FILE_URL);

              case 2:
                response = _context.sent;
                _context.next = 5;
                return response.json();

              case 5:
                navConfig = _context.sent;
                stringified = JSON.stringify(navConfig);

                if (stringified !== storedConfig) {
                  localStorage.setItem(LOCALSTORAGE_NAVBAR_CONFIG_KEY, stringified);
                  setConfig(navConfig);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData();
  }, []); // Need to process all objects as title values to the localised string

  var processedPrimaryItems = translate(config, lang);
  return React.createElement(React.Fragment, null, React.createElement("header", {
    className: "mobile-header bg-white static-top"
  }, React.createElement("div", {
    className: "container d-flex"
  }, React.createElement("div", {
    className: "brand split-brand"
  }, primarySignet, React.createElement("div", {
    className: "split"
  }), secondarySignet), mobileTopSlot)), React.createElement("nav", {
    className: "navbar navbar-expand-lg navbar-dark navbar-global bg-primary static-top "
  }, React.createElement("div", {
    className: "container"
  }, primaryLogo, React.createElement("div", {
    className: "collapse navbar-collapse",
    id: "navbarDisappear"
  }, React.createElement("ul", {
    className: "navbar-nav ml-auto"
  }, processedPrimaryItems.map(function (item, i) {
    return React.createElement(ItemComponent, {
      item: Object.assign(Object.assign({}, item), {
        icon: undefined
      }),
      key: i
    });
  })), React.createElement("ul", {
    className: "navbar-icon-row "
  }, primaryActionItems.map(function (item, i) {
    return React.createElement(ActionItem, {
      item: item,
      key: i
    });
  })), primarySlot))), React.createElement("nav", {
    className: "navbar navbar-expand-lg navbar-light bg-white sticky-top"
  }, React.createElement("div", {
    className: "container"
  }, secondaryLogo, React.createElement("div", {
    className: "mobile-nav-container"
  }, React.createElement("div", {
    className: "navbar-mobile"
  }, React.createElement("ul", {
    className: "navbar-mobile-nav light-icon"
  }, secondaryNavItems.map(function (item, i) {
    return item.icon ? React.createElement(ItemComponent, {
      item: Object.assign(Object.assign({}, item), {
        title: undefined
      }),
      key: i
    }) : null;
  }))), React.createElement("button", {
    className: "navbar-toggler light-icon collapsed",
    type: "button",
    id: "navbarToggler",
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    "aria-controls": "navbarResponsive",
    "aria-expanded": expanded,
    "aria-label": "Toggle navigation"
  }, expanded ? React.createElement(Icon, {
    icon: ICONS.CLOSE,
    className: "navbar-toggler-icon"
  }) : React.createElement(Icon, {
    icon: ICONS.MENU,
    className: "navbar-toggler-icon"
  }))), React.createElement("div", {
    className: "collapse navbar-collapse",
    id: "navbarResponsive_"
  }, React.createElement("ul", {
    className: "navbar-nav ml-auto"
  }, secondaryNavItems.map(function (item, i) {
    return React.createElement(ItemComponent, {
      key: i,
      item: Object.assign(Object.assign({}, item), {
        icon: undefined
      })
    });
  })), secondarySlot))), React.createElement("div", {
    className: classNames("collapse nav-drawer", {
      show: expanded
    }),
    id: "navbarResponsive"
  }, React.createElement("div", {
    className: "navbar-collapse"
  }, React.createElement("ul", {
    className: "navbar-nav"
  }, secondaryNavItems.map(function (item, i) {
    return React.createElement(ItemComponent, {
      key: i,
      item: Object.assign(Object.assign({}, item), {
        icon: ""
      })
    });
  }))), React.createElement("div", {
    className: "absolute-bottom"
  }, React.createElement("ul", {
    className: "navbar-icon-row "
  }, primaryActionItems.map(function (item, i) {
    return React.createElement(ActionItem, {
      key: i,
      item: item
    });
  })), drawerSlot)), React.createElement("div", {
    style: {
      height: 40
    }
  }));
};